export interface ColorFieldProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
}

/** A hex color picker: a native swatch paired with an editable hex text field. */
export function ColorField({ label, value, onChange }: ColorFieldProps) {
  return (
    <div className="mb-2">
      {label && <label className="form-label">{label}</label>}
      <div className="input-group" style={{ maxWidth: 200 }}>
        <input
          type="color"
          className="form-control form-control-color"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          title={label}
        />
        <input
          type="text"
          className="form-control"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  );
}
